import { useMemo, useState } from 'react';
import type { BooleanActions } from '@/components/ui/lib/use-boolean-types';

export function useBoolean(initialValue = false): [boolean, BooleanActions] {
  const [value, setValue] = useState(initialValue);
  const actions = useMemo(
    () => ({
      on: () => {
        setValue(true);
      },
      off: () => {
        setValue(false);
      },
      toggle: () => {
        setValue((v) => !v);
      },
    }),
    [],
  );
  return [value, actions];
}
